var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('HeadMenu',{directives:[{name:"show",rawName:"v-show",value:(_vm.showType),expression:"showType"}]}),_vm._v(" "),_c('router-view',{on:{"showType":_vm.recvShowType}}),_vm._v(" "),_c('Footer',{directives:[{name:"show",rawName:"v-show",value:(_vm.showType),expression:"showType"}]})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0f13170","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 